module.exports = __webpack_public_path__ + "img/home-selling-point0.872b57ea.png";